import api from './api'
import { stringify } from 'querystring'

const findWorkHours = (monthAndYear) => api.get(`work-hours?${stringify(monthAndYear)}`, { responseType: 'arraybuffer', timeout: 60000 })

export { findWorkHours }
